import { render, staticRenderFns } from "./AmendDetails.vue?vue&type=template&id=20ebd35c&scoped=true&"
import script from "./AmendDetails.vue?vue&type=script&lang=js&"
export * from "./AmendDetails.vue?vue&type=script&lang=js&"
import style0 from "./AmendDetails.vue?vue&type=style&index=0&id=20ebd35c&lang=scss&scoped=true&"
import style1 from "./AmendDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ebd35c",
  null
  
)

export default component.exports